import React from 'react';
import { Button } from '@/components/ui/button';
import ItemPriceManager from './ItemPriceManager';
import { useState } from 'react';

interface ItemPriceManagerTabProps {
  itemId: number;
  itemName: string;
}

export const ItemPriceManagerTab: React.FC<ItemPriceManagerTabProps> = ({ itemId, itemName }) => {
  const [open, setOpen] = useState(false);

  return (
    <div className="space-y-4">
      <div className="text-center py-8">
        <h3 className="text-lg font-medium mb-2">Manage Item Pricing</h3>
        <p className="text-muted-foreground mb-4">
          Set base prices and configure sale price rules for automatic price calculation.
        </p>
        <Button onClick={() => setOpen(true)}>
          Open Price Manager
        </Button>
      </div>
      
      <ItemPriceManager
        itemId={itemId}
        itemName={itemName}
        open={open}
        onOpenChange={setOpen}
      />
    </div>
  );
};